export const GET_EMPLOYEE_BY_ID = "employee_details";
export const GET_EMPLOYEE_BY_ID_SUCCESS = "employee_details_success";
export const GET_EMPLOYEE_BY_ID_FAILURE = "employee_details_failure";
